module.exports = __webpack_public_path__ + "static/media/Header_Shadow@2x.7824436d.png";